import * as React from 'react';
import { Header4 } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { formatPhoneNumber } from '@cian/newbuilding-utils';
import { getPhone } from '../../selectors';
import * as styles from './PikPhoneNumber.css';

export function PikPhoneNumber() {
  const phone = useSelector(getPhone);

  if (!phone) {
    return null;
  }

  return (
    <a className={styles['pik-number']} href={`tel:${phone}`}>
      <Header4 color="black_100">{formatPhoneNumber(phone)}</Header4>
    </a>
  );
}
